import React, { useState } from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const revealRef = useScrollReveal();
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: 'Čo je PWA a prečo by som ju mal zvážiť?',
    answer: 'PWA (Progressive Web App) je webová aplikácia, ktorá sa správa ako natívna mobilná aplikácia. Funguje offline, dá sa nainštalovať na plochu jedným klikom bez App Storu a ponúka natívny výkon. Šetrí náklady na vývoj, keďže nepotrebujete samostatný kód pre iOS a Android.'
  }, {
    question: 'Ako funguje Gemini Multimodal Embeddings?',
    answer: 'Je to AI technológia od Googlu, ktorá dokáže súčasne spracovávať text, obraz, video a zvuk. Vytvára jednotný "vektorový odtlačok" významu, čo umožňuje napríklad vyhľadávať vo videách pomocou textu alebo analyzovať obrázky na základe zvukových pokynov.'
  }, {
    question: 'Koľko stojí vývoj PWA aplikácie?',
    answer: 'Cena závisí od komplexnosti projektu. Vďaka nášmu modulárnemu prístupu a využitiu hotových AI modelov vieme dodať MVP (Minimum Viable Product) za zlomok ceny tradičného vývoja. Presnú kalkuláciu vám pripravíme po úvodnej konzultácii.'
  }, {
    question: 'Ako dlho trvá vývoj?',
    answer: 'Pracujeme v 14-dňových šprintoch. Prvú fungujúcu verziu (MVP) zvyčajne dodávame do 4 až 8 týždňov. Následne aplikáciu iteratívne vylepšujeme na základe reálnej spätnej väzby od používateľov.'
  }, {
    question: 'Funguje PWA offline?',
    answer: 'Áno. Vďaka technológii Service Workers dokáže PWA ukladať dáta do vyrovnávacej pamäte zariadenia. Používatelia môžu s aplikáciou pracovať aj bez pripojenia na internet a dáta sa automaticky zosynchronizujú, keď sa pripojenie obnoví.'
  }, {
    question: 'Aké technológie používate?',
    answer: 'Naše stack je postavený na moderných a overených technológiách: React a TypeScript pre frontend, Tailwind CSS pre dizajn, a Google Gemini 2.0 pre AI funkcionalitu. Všetko optimalizované pre maximálny výkon a bezpečnosť.'
  }];
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section ref={revealRef} className="py-36 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto overflow-hidden" data-id="element-21">
      <div className="reveal text-center mb-20" data-id="element-22">
        <h2 className="text-4xl md:text-6xl font-extrabold tracking-tight text-apple-black mb-6" data-id="element-23">
          Často Kladené Otázky
        </h2>
        <p className="text-xl text-apple-gray font-light" data-id="element-24">
          Všetko, čo potrebujete vedieť o našich technológiách a procesoch.
        </p>
      </div>

      <div className="reveal space-y-4" data-id="element-25">
        {faqs.map((faq, index) => <div key={index} className={`border border-gray-200 rounded-2xl bg-white overflow-hidden transition-all duration-300 ${openIndex === index ? 'shadow-md border-apple-blue/30' : 'hover:border-gray-300'}`} data-id="element-26">
            <button onClick={() => toggleFaq(index)} className="w-full px-8 py-6 flex justify-between items-center text-left focus:outline-none" data-id="element-27">
              <span className="text-lg font-bold text-apple-black pr-8" data-id="element-28">
                {faq.question}
              </span>
              <ChevronDownIcon className={`w-6 h-6 text-apple-blue flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-29" />
            </button>
            <div className={`px-8 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-30">
              <p className="text-apple-gray font-light leading-relaxed" data-id="element-31">
                {faq.answer}
              </p>
            </div>
          </div>)}
      </div>
    </section>;
}